import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { SearchArgument } from '@/models/client/my-order'

const URL = '/rest/customer/shop/customer-score-orders'
const EXPRESS = '/rest/customer/shop/customer-score-orders/{id}'

export default {
  list ({search}, cb) {
    http.get(URL, {
      params: convert.toJson(search, SearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getExpress (id, cb) {
    http.get(EXPRESS.replace('{id}', id)).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/my-order.js